var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 80,
    viewBox: "0 0 103 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JCB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element",
    d: "M102.976 63.3212C102.976 72.1333 95.8004 79.3089 86.9883 79.3089H0V15.9877C0 7.17557 7.17559 0 15.9877 0H102.976V63.3212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Element_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5055 5.35034C74.2112 5.35034 69.0498 10.4488 69.0498 16.8061V28.7024H85.2263C85.604 28.7024 86.0446 28.7024 86.3593 28.7653C90.01 28.9542 92.7166 30.8425 92.7166 34.1155C92.7166 36.6962 90.8912 38.8993 87.4923 39.3399V39.4658C91.206 39.7175 94.0384 41.7947 94.0384 45.0048C94.0384 48.4667 90.8912 50.7327 86.737 50.7327H68.9868V74.0218H85.7928C92.0872 74.0218 97.2486 68.9233 97.2486 62.566V5.35034H80.5055Z",
    fill: "url(#paint0_linear_461_4517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6522 47.0819H81.2613C81.3557 47.0819 81.5131 47.0662 81.6704 47.0505C81.8277 47.0347 81.9852 47.019 82.0796 47.019C83.3384 46.7672 84.4085 45.6342 84.4085 44.0606C84.4085 42.55 83.3384 41.417 82.0796 41.1023C81.8907 41.0394 81.5131 41.0394 81.2613 41.0394H74.6522V47.0819Z",
    fill: "url(#paint1_linear_461_4517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2613 32.1644C82.5202 32.3532 83.5902 33.3603 83.5902 34.8709C83.5902 36.3816 82.5202 37.3887 81.2613 37.5775C81.1983 37.6405 80.8207 37.6405 80.6319 37.6405H74.6522V32.1014H80.6318C80.7358 32.1014 80.8779 32.1205 81.0057 32.1377C81.11 32.1517 81.2047 32.1644 81.2613 32.1644Z",
    fill: "url(#paint2_linear_461_4517)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Element_3",
    d: "M17.1837 5.35034C10.8894 5.35034 5.72798 10.4488 5.72798 16.8061V45.0677C8.93811 46.6413 12.2741 47.6484 15.6102 47.6484C19.5756 47.6484 21.7157 45.2566 21.7157 41.9835V28.6395H31.5349V41.9206C31.5349 47.0819 28.3248 51.2991 17.4355 51.2991C10.8264 51.2991 5.66504 49.8514 5.66504 49.8514V73.9588H22.471C28.7654 73.9588 33.9268 68.8604 33.9268 62.5031V5.35034H17.1837Z",
    fill: "url(#paint3_linear_461_4517)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_4",
    d: "M48.8444 5.35034C42.5501 5.35034 37.3887 10.4488 37.3887 16.8061V31.7866C40.2841 29.3318 45.3196 27.7582 53.4393 28.1359C57.7825 28.3247 62.4403 29.5207 62.4403 29.5207V34.3673C60.1114 33.1714 57.3418 32.1014 53.754 31.8496C47.5856 31.409 43.8719 34.4303 43.8719 39.7175C43.8719 45.0677 47.5856 48.089 53.754 47.5855C57.3418 47.3337 60.1114 46.2007 62.4403 45.0677V49.9144C62.4403 49.9144 57.8454 51.1103 53.4393 51.2991C45.3196 51.6768 40.2841 50.1032 37.3887 47.6484V74.0847H54.1947C60.489 74.0847 65.6504 68.9863 65.6504 62.629V5.35034H48.8444Z",
    fill: "url(#paint4_linear_461_4517)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_461_4517",
    x1: 69.039,
    y1: 34.8631,
    x2: 97.3254,
    y2: 34.8631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_461_4517",
    x1: 69.039,
    y1: 34.8631,
    x2: 97.3254,
    y2: 34.8631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_461_4517",
    x1: 69.039,
    y1: 34.8631,
    x2: 97.3254,
    y2: 34.8631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_461_4517",
    x1: 5.71465,
    y1: 39.6586,
    x2: 34.4378,
    y2: 39.6586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_461_4517",
    x1: 37.2259,
    y1: 39.6586,
    x2: 65.1228,
    y2: 39.6586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.704b4ae8f662f46d7c6d30def8cb0893.svg";
export { ForwardRef as ReactComponent };